import Checkbox from "@mui/material/Checkbox"
import FormControlLabel from "@mui/material/FormControlLabel"
import TextField from "@mui/material/TextField"
import type { FC } from "react"
import { Controller, useFormContext } from "react-hook-form"

import type { ProductPreTestNoteFormValues } from "../../schemas"

import { TEXT_AREA_STYLING_PROPS } from "@/constants/forms"

export const ProductPreTestNoteForm: FC = () => {
  const { control } = useFormContext<ProductPreTestNoteFormValues>()

  return (
    <>
      <Controller
        name='printExpirationToAkrochemCoa'
        control={control}
        render={({ field }) => (
          <FormControlLabel
            control={
              <Checkbox
                {...field}
                checked={field.value}
                onChange={(e) => field.onChange(e.target.checked)}
                data-testid='print-expiration-checkbox'
              />
            }
            label='Print Expiration to Akrochem COA'
          />
        )}
      />
      <Controller
        name='printMfgDatesToAkrochemCoa'
        control={control}
        render={({ field }) => (
          <FormControlLabel
            control={
              <Checkbox
                {...field}
                checked={field.value}
                onChange={(e) => field.onChange(e.target.checked)}
                data-testid='print-mfg-dates-checkbox'
              />
            }
            label='Print Mfg Dates to Akrochem COA'
          />
        )}
      />
      <Controller
        name='printPreTestNotesToAkrochemCoa'
        control={control}
        render={({ field }) => (
          <FormControlLabel
            control={
              <Checkbox
                {...field}
                checked={field.value}
                onChange={(e) => field.onChange(e.target.checked)}
                data-testid='print-pre-test-notes-checkbox'
              />
            }
            label='Print Pre Test Notes to Akrochem COA'
          />
        )}
      />
      <Controller
        name='preTestNotes'
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            {...TEXT_AREA_STYLING_PROPS}
            id='pre-test-notes-input'
            data-testid='pre-test-notes-input'
            placeholder='Add pre-test note...'
            minRows={3}
            className='mt-6'
          />
        )}
      />
    </>
  )
}
